import packageJson from '../../package.json';
export default (message => `Logger v${packageJson.version} : ${message}`);